module.exports = __webpack_public_path__ + "components/country-flag/static/ee-0efa1e2f71a96b7572447d1d457e6f4f.svg";